import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, SendIcon } from 'lucide-react';
interface DemoModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function DemoModal({
  isOpen,
  onClose
}: DemoModalProps) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      onClose();
    }, 3000);
  };
  return <AnimatePresence data-id="element-34">
      {isOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-35">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-midnight-navy/80 backdrop-blur-md" data-id="element-36" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-lg bg-stark-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-37">
            <button onClick={onClose} className="absolute top-4 right-4 p-2 text-midnight-navy/40 hover:text-midnight-navy transition-colors" data-id="element-38">
              <XIcon className="w-6 h-6" data-id="element-39" />
            </button>

            <div className="p-8 md:p-12" data-id="element-40">
              {!isSubmitted ? <div className="space-y-8" data-id="element-41">
                  <div className="space-y-2" data-id="element-42">
                    <h2 className="text-3xl font-manrope font-bold text-midnight-navy" data-id="element-43">
                      Book a Demo
                    </h2>
                    <p className="text-midnight-navy/60" data-id="element-44">
                      See how ROI can transform your restaurant operations.
                    </p>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-4" data-id="element-45">
                    <div className="grid grid-cols-2 gap-4" data-id="element-46">
                      <div className="space-y-1.5" data-id="element-47">
                        <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-48">
                          First Name
                        </label>
                        <input required type="text" className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors" placeholder="Jane" data-id="element-49" />
                      </div>
                      <div className="space-y-1.5" data-id="element-50">
                        <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-51">
                          Last Name
                        </label>
                        <input required type="text" className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors" placeholder="Doe" data-id="element-52" />
                      </div>
                    </div>

                    <div className="space-y-1.5" data-id="element-53">
                      <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-54">
                        Email
                      </label>
                      <input required type="email" className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors" placeholder="jane@example.com" data-id="element-55" />
                    </div>

                    <div className="space-y-1.5" data-id="element-56">
                      <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-57">
                        Phone
                      </label>
                      <input required type="tel" className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors" placeholder="(555) 000-0000" data-id="element-58" />
                    </div>

                    <div className="space-y-1.5" data-id="element-59">
                      <label className="text-xs font-bold uppercase tracking-wider text-midnight-navy/40" data-id="element-60">
                        Message
                      </label>
                      <textarea rows={3} className="w-full px-4 py-3 bg-cool-gray border border-gray-200 rounded-lg focus:outline-none focus:border-accent-red transition-colors resize-none" placeholder="How can we help you?" data-id="element-61" />
                    </div>

                    <button type="submit" className="w-full bg-accent-red text-stark-white py-4 rounded-full font-bold hover:bg-red-700 transition-all shadow-xl shadow-accent-red/20 flex items-center justify-center gap-2 mt-4" data-id="element-62">
                      Request Walkthrough
                      <SendIcon className="w-4 h-4" data-id="element-63" />
                    </button>
                  </form>
                </div> : <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="py-12 text-center space-y-6" data-id="element-64">
                  <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto" data-id="element-65">
                    <CheckIcon className="w-10 h-10" data-id="element-66" />
                  </div>
                  <div className="space-y-2" data-id="element-67">
                    <h3 className="text-2xl font-manrope font-bold text-midnight-navy" data-id="element-68">
                      Request Received
                    </h3>
                    <p className="text-midnight-navy/60" data-id="element-69">
                      An operations specialist will be in touch shortly to
                      schedule your demo.
                    </p>
                  </div>
                </motion.div>}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}
function CheckIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-70">
      <polyline points="20 6 9 17 4 12" data-id="element-71" />
    </svg>;
}